import { useScrollAnimation } from "../../hooks/useScrollAnimation";

export const FounderNote = () => {
  const [ref, isVisible] = useScrollAnimation();
  const [ref2, isVisible2] = useScrollAnimation();

  return (
    <section id="about" className="relative">
      <div className="max-w-[1180px] mx-auto px-5 md:px-10">
        <div className="h-px bg-[rgba(10,10,10,0.08)]" />
      </div>

      <div className="max-w-[920px] mx-auto px-5 md:px-10 py-[60px] md:py-[80px] lg:py-[120px]">
        <h2 className="text-[clamp(26px,4vw,40px)] font-semibold leading-[1.2] tracking-tight text-[#0A0A0A] mb-16">
          Why &ldquo;Built by Founders&rdquo; Matters
        </h2>

        {/* Nishant's Note */}
        <div
          ref={ref}
          className={`transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <div className="border-l-2 border-[#4A7CC9] pl-7 md:pl-10">
            <div className="space-y-6 text-[clamp(16px,2vw,18px)] leading-[1.7] text-[rgba(10,10,10,0.55)]">
              <p>
                The Fussed Bulb wasn't born in an agency boardroom.
              </p>
              <p className="text-[#0A0A0A] font-medium">
                It was built while building brands.
              </p>
              <p>
                I've navigated product launches, pivots, uncertainty, and growth
                from the inside. I understand capital pressure, decision fatigue,
                and the weight of responsibility.
              </p>
              <p className="text-[#0A0A0A] font-medium">
                That's why we don't sell services.
              </p>
              <p>We build alongside founders.</p>
            </div>

            <div className="mt-10">
              <p className="text-[15px] font-medium text-[#0A0A0A]">
                - Nishant Menaria
              </p>
              <p className="text-[13px] italic text-[rgba(10,10,10,0.4)] mt-1">
                Co-Founder, The Fussed Bulb
              </p>
            </div>
          </div>
        </div>

        {/* Nikhil's Note */}
        <div
          ref={ref2}
          className={`mt-16 md:mt-20 transition-all duration-700 delay-150 ${
            isVisible2 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <div className="border-l-2 border-[rgba(10,10,10,0.15)] pl-7 md:pl-10">
            <div className="space-y-6 text-[clamp(16px,2vw,18px)] leading-[1.7] text-[rgba(10,10,10,0.55)]">
              <p>
                Every bold vision needs a sharp system behind it.
              </p>
              <p>
                I believe strategy without structure is just wishful thinking.
                At The Fussed Bulb, I focus on turning clarity into action -
                mapping out the steps, building the processes, and making sure
                every decision moves the needle.
              </p>
              <p className="text-[#0A0A0A] font-medium text-[clamp(17px,2.2vw,20px)]">
                "We don't just dream - we create a plan."
              </p>
            </div>

            <div className="mt-10">
              <p className="text-[15px] font-medium text-[#0A0A0A]">
                - Nikhil Choudhary
              </p>
              <p className="text-[13px] italic text-[rgba(10,10,10,0.4)] mt-1">
                Co-Founder, The Fussed Bulb
              </p>
              <p className="text-[13px] text-[rgba(10,10,10,0.35)] mt-0.5">
                Strategy & Operations
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
